"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setInterviewQuotaIds = exports.setQuotafull = exports.doRedirect = exports.initMetrikaCounter = exports.setLang = exports.setDims = exports.setThemeMode = exports.removeNotification = exports.addNotification = exports.toggleHiddenQuestionsDisplay = exports.setHiddenQuestionsDisplay = exports.widgetCompleted = exports.testResizedToMin = exports.detectScroll = exports.incrementSeqNum = exports.resize = exports.surveySkip = exports.restoreSurveyFromPreloadedState = void 0;
const restoreSurveyFromPreloadedState = () => {
    return {
        type: 'SURVEY_RESTORED_FROM_PRELOADED_STATE'
    };
};
exports.restoreSurveyFromPreloadedState = restoreSurveyFromPreloadedState;
const surveySkip = () => {
    return {
        type: 'SURVEY_SKIP'
    };
};
exports.surveySkip = surveySkip;
const resize = () => {
    return {
        type: 'RESIZE'
    };
};
exports.resize = resize;
const incrementSeqNum = () => {
    return {
        type: 'SURVEY_INCREMENT_SEQ_NUM'
    };
};
exports.incrementSeqNum = incrementSeqNum;
const detectScroll = () => {
    return {
        type: 'DETECTED_SCROLL_ON_SURVEY'
    };
};
exports.detectScroll = detectScroll;
const testResizedToMin = () => {
    return {
        type: 'TEXT_RESIZED_TO_MIN'
    };
};
exports.testResizedToMin = testResizedToMin;
const widgetCompleted = (widgetId) => {
    return {
        type: 'WIDGET_COMPLETED',
        widgetId
    };
};
exports.widgetCompleted = widgetCompleted;
const setHiddenQuestionsDisplay = (value) => {
    return {
        type: 'SET_HIDDEN_QUESTIONS_DISPLAY',
        value
    };
};
exports.setHiddenQuestionsDisplay = setHiddenQuestionsDisplay;
const toggleHiddenQuestionsDisplay = () => {
    return {
        type: 'TOGGLE_HIDDEN_QUESTIONS_DISPLAY'
    };
};
exports.toggleHiddenQuestionsDisplay = toggleHiddenQuestionsDisplay;
const addNotification = (message) => ({
    type: 'ADD_NOTIFICATION',
    message
});
exports.addNotification = addNotification;
const removeNotification = () => ({
    type: 'REMOVE_NOTIFICATION'
});
exports.removeNotification = removeNotification;
const setThemeMode = (mode) => ({
    type: 'SET_THEME_MODE',
    mode
});
exports.setThemeMode = setThemeMode;
const setDims = (dims) => ({
    type: 'SET_DIMS',
    dims
});
exports.setDims = setDims;
const setLang = () => {
    return {
        type: 'LANG_SET'
    };
};
exports.setLang = setLang;
const initMetrikaCounter = () => {
    return {
        type: 'METRIKA_INIT'
    };
};
exports.initMetrikaCounter = initMetrikaCounter;
const doRedirect = (url) => {
    return {
        type: 'REDIRECT',
        url
    };
};
exports.doRedirect = doRedirect;
const setQuotafull = (redirect) => {
    return {
        type: 'QUOTAFULL',
        data: { redirect }
    };
};
exports.setQuotafull = setQuotafull;
const setInterviewQuotaIds = (quotaIds) => {
    return {
        type: 'SET_INTERVIEW_QUOTAS',
        data: { quotaIds }
    };
};
exports.setInterviewQuotaIds = setInterviewQuotaIds;
